import { render, staticRenderFns } from "./customization.vue?vue&type=template&id=5adb65b4&scoped=true"
import script from "./customization.vue?vue&type=script&lang=js"
export * from "./customization.vue?vue&type=script&lang=js"
import style0 from "./customization.vue?vue&type=style&index=0&id=5adb65b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adb65b4",
  null
  
)

export default component.exports